import React from 'react';
import proptypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { SweepstakesFullComponent } from '@thd-olt-component-react/loyalty-benefits';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

const { string } = proptypes;

export function Sweepstakes({ id }) {
  return (
    <ErrorBoundary name="sweepstakes-full">
      <QueryProvider key={id} cacheKey={id}>
        <SweepstakesFullComponent componentId={id} useRestAPI />
      </QueryProvider>
    </ErrorBoundary>
  );
}

Sweepstakes.propTypes = {
  id: string,
};

Sweepstakes.defaultProps = {
  id: undefined,
};
